import { GridEditInputCell, GridEditInputCellProps } from '@mui/x-data-grid';
import { RefAttributes } from 'react';
import { JSX } from 'react/jsx-runtime';

export const NoSpinnerInput = (
  props: JSX.IntrinsicAttributes &
    Pick<GridEditInputCellProps, keyof GridEditInputCellProps> &
    RefAttributes<HTMLInputElement>,
) => (
  <GridEditInputCell
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    inputProps={{
      inputMode: 'decimal',
      type: 'number',
    }}
    sx={{
      '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
      },
      '& input[type=number]': {
        MozAppearance: 'textfield',
      },
    }}
  />
);
